import { Home, Calendar, PaperPlus, Graph, Swap, Paper, Notification } from "react-iconly";
import {FiDatabase} from "react-icons/fi";
import IntlMessages from "../../layout/components/lang/IntlMessages";


const main = [
    {
        header: <IntlMessages id="sidebar-main" />,
    },
    {
        id: "sidebar-dashboard-eCommerce",
        title: <IntlMessages id="sidebar-dashboard-eCommerce" />,
        icon: <Home set="curved" />,
        navLink: "/travel-dashboard",
    },
    {
        id: "sidebar-new-travel-request",
        title: <IntlMessages id="sidebar-new-travel-request" />,
        icon: <PaperPlus set="curved" />,
        navLink: "/travel-dashboard/travel-request",
    },
    {
        id: "sidebar-new-travel-table",
        title: <IntlMessages id="sidebar-new-travel-table" />,
        icon: <Paper set="curved" />,
        navLink: "/travel-dashboard/travel-table",
    },
    {
        id: "sidebar-notification-list",
        title: <IntlMessages id="sidebar-notification-list" />,
        icon: <Notification set="curved"/>,
        navLink: "/notification-list",
    },
    {
        id: "sidebar-dashboard-options",
        title: <IntlMessages id="sidebar-dashboard-options" />,
        icon: <Swap set="curved"/>,
        navLink: "/dashboard-options",
    },
    {
        id: "sidebar-variables",
        title: <IntlMessages id="sidebar-variables" />,
        icon: <FiDatabase set="curved" className="remix-icon" />,
        children: [
            {
                id: "sidebar-variables-currency",
                title: <IntlMessages id="sidebar-variables-currency" />,
                navLink: "/system-variables/currencies",
            },
            {
                id: "sidebar-variables-payment-types",
                title: <IntlMessages id="sidebar-variables-payment-types" />,
                navLink: "/system-variables/payment-types",
            },
            {
                id: "sidebar-variables-service-categories",
                title: <IntlMessages id="sidebar-variables-service-categories" />,
                navLink: "/system-variables/service-categories",
            },
            {
                id: "sidebar-variables-vendors",
                title: <IntlMessages id="sidebar-variables-vendors" />,
                navLink: "/system-variables/vendors",
            },
            {
                id: "sidebar-variables-projects",
                title: <IntlMessages id="sidebar-variables-projects" />,
                navLink: "/system-variables/projects",
            }
        ],

    }
];


export default main